import { styled } from "~/common/mui";

export interface CardProps {
  size?: CardSize;
  isHoverable?: boolean;
  "data-test-id"?: string;
  bordered?: boolean;
}

export enum CardSize {
  TINY,
  SMALL,
  DEFAULT,
}

const CardRoot = styled("div", {
  shouldForwardProp: (prop) => prop !== "$size" && prop !== "$bordered",
})<{ $size: CardSize; $bordered: boolean }>(({ theme, $size, $bordered }) => ({
  padding:
    $size === CardSize.TINY
      ? theme.spacing(1.25)
      : $size === CardSize.SMALL
        ? theme.spacing(2.5)
        : theme.spacing(3.75),
  ...($bordered && {
    border: `1px solid ${theme.palette.divider}`,
  }),
}));

const Card: React.FunctionComponent<CardProps & JSX.IntrinsicElements["div"]> = (props) => {
  const { size = CardSize.DEFAULT, bordered = true, className, ...elementProps } = props;

  return <CardRoot $size={size} $bordered={bordered} className={className} {...elementProps} />;
};

export default Card;
